<template>
  <form class="dashboard-block">
    <h2>Notify Others</h2>
    <p>Add multiple email addresses in here to keep other stakeholders notified of any requests, separated by ';'</p>
    <div class="panel panel-grey">
      <div class="panel-body">
        <div class="form-horizontal">
            <div :class="['form-group', errorClass('clubEmail')]">
              <label class="control-label sr-only">Notify Others:</label>
              <div >
                <input
                  name="email"
                  type="email"
                  class="form-control"
                  placeholder="e.g. ea@agency.com; scheduling@sportsteam.com"
                  v-model="$v.stateClubContact.$model">
                  <p v-if="$v.stateClubContact.$error && submitted" class="help-block pull-left">Each entry must be a valid email address, separated by ';'</p>
              </div>
            </div>
        </div>
      </div>
      <div class="panel-footer">
        <ladda-button
          type="submit"
          class="btn btn-sm btn-primary"
          :click="handleSaveClubContact"
          :disabled="userIsAdmin && !canEditAdmin">
          Save and Update
        </ladda-button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { stateMapper, helpers as userHelpers } from 'mixins/users'
import { handleServerErrors, notify } from 'utils'
import { email } from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'

export default {
  mixins: [stateMapper, userHelpers],

  computed: mapState('user', ['user']),

  components: [VuelidateHelp],

  data () {
    return {
      submitted: false
    }
  },

  validations () {
    return {
      stateClubContact: {
        multipleEmails (entry) {
          if (!entry) {
            return false
          }
          const entries = entry.split(';')
          for (let i = 0; i < entries.length; i++) {
            if (!email(entries[i].trim())) {
              return false
            }
          }
          return true
        }
      }
    }
  },

  methods: {
    ...mapActions('user', ['updateUser']),

    /**
     * Handle changing the users password.
     *
     * Validate the data before sending.
     *
     * @return Promise
     */
    handleSaveClubContact () {
      if (this.$v.$invalid) {
        notify.error('Validations failed, please check for errors and try again.')
        this.submitted = true
        return Promise.resolve()
      }
      return this.updateUser({
        id: this.user.id,
        payload: {
          club_contact: this.stateClubContact
        }
      })
        .then(() => {
          notify.success('Successfully saved club contact')
        })
        .catch((error) => {
          if (error.response) {
            handleServerErrors(error, this.errors)
          } else {
            notify.error('Sorry something has gone wrong, please try again.')
            throw error
          }
        })
    }
  }
}
</script>
